import React from "react";
import PropTypes from 'prop-types';

import { MessageBoxGlobal } from '../../common/globals/globals';

import AGGridComponent, { COLUMN_MEDIUM, COLUMN_MEDIUM_MEDIUM, COLUMN_LARGE, COLUMN_EXTRA_LARGE, COLUMN_WIDE, COLUMN_EXTRA_WIDE, COLUMN_EXTRA_EXTRA_WIDE } from '../../common/components/grid/ag-grid-component';

const AutoUpdateGridComponent = (props) => {
  const { messageBoxGlobal, data } = props;

  const reformatDateValue = (value) => {
    if (value === null || value === undefined) return null;
    let dateValue = value.toISOString();
    let formattedDate = new Date(dateValue).toLocaleString().split(',')[0];

    return formattedDate;
  }

  const dateCompare = (filterLocalDateAtMidnight, cellValue) => {
    const dateAsString = cellValue;

    if (dateAsString == null) {
      return 0;
    }

    let dateValue = dateAsString.toISOString();
    let cellDate = new Date(dateValue).toLocaleString().split(',')[0];

    let agDateValue = filterLocalDateAtMidnight.toISOString();
    let agDateFormatted = new Date(agDateValue).toLocaleString().split(',')[0];

    if (cellDate < agDateFormatted) {
      return -1;
    } else if (cellDate > agDateFormatted) {
      return 1;
    }
    return 0;
  }

  const columnDefs = [];
  columnDefs.push({ headerName: 'Entity Name', suppressHeaderMenuButton: false, resizable: true, field: 'entityName', sortable: true, filter: 'agTextColumnFilter', editable: false, width: COLUMN_MEDIUM_MEDIUM, type: 'text' });
  columnDefs.push({ headerName: 'Update type', suppressHeaderMenuButton: false, resizable: true, field: 'logType', sortable: true, filter: 'agTextColumnFilter', editable: false, width: COLUMN_MEDIUM_MEDIUM, type: 'text' });
  columnDefs.push({ headerName: 'Entity Type', suppressHeaderMenuButton: false, resizable: true, field: 'entityType', sortable: true, filter: 'agTextColumnFilter', editable: false, width: COLUMN_MEDIUM_MEDIUM, type: 'text' });
  columnDefs.push({ headerName: 'Country', suppressHeaderMenuButton: false, resizable: true, field: 'countryName', sortable: true, filter: 'agTextColumnFilter', editable: false, width: COLUMN_MEDIUM_MEDIUM, type: 'text' });
  columnDefs.push({
    headerName: 'Update Date',
    suppressHeaderMenuButton: false,
    resizable: true,
    field: 'messageDateTime',
    sortable: true,
    filter: 'agDateColumnFilter',
    filterParams: {
      comparator: (filterLocalDateAtMidnight, cellValue) => {
        return dateCompare(filterLocalDateAtMidnight, cellValue);
      }
    },
    editable: false,
    width: COLUMN_MEDIUM_MEDIUM,
    type: 'text',
    valueFormatter: function (params) {
      return reformatDateValue(params.value);
    }
  });
  columnDefs.push({ headerName: 'Message', suppressHeaderMenuButton: false, resizable: true, field: 'message', sortable: true, filter: 'agTextColumnFilter', editable: false, width: COLUMN_EXTRA_EXTRA_WIDE, type: 'text' });

  const columnTypes = {
    numeric: {},
    text: {},
    percent: {},
    none: {},
    dropdown: {},
    image: {}
  };

  return (
    <AGGridComponent
      messageBoxGlobal={messageBoxGlobal}
      columnDefs={columnDefs}
      rowsCount={data.length}
      columnTypes={columnTypes}
      gridData={data}
      allowPaste={false}
      editYear={0}
      autoResize
    />
  );
};

AutoUpdateGridComponent.propTypes = {
  messageBoxGlobal: PropTypes.instanceOf(MessageBoxGlobal).isRequired,
};

export default AutoUpdateGridComponent;
